import React from "react";
import { currentLocals } from "../../languages/languages.js";
//import { useTour } from "@reactour/tour";
import { useTour } from "@lectra/mui-library";

import getTourSteps from "../../Tour/TourSteps";
import getWhatIsNewSteps from "../../Tour/WhatIsNewSteps";
import { SupportedLocale } from "@lectra/mui-library";

const HelpMenu = ({ locale }) => {
  const { setIsOpen, setSteps, setCurrentStep } = useTour();

  locale = locale === undefined ? SupportedLocale.EN : locale;
  function SelectMyLectra() {
    window.open("https://login.mylectra.com/");
  }

  function SelectDiscovery() {
    setIsOpen(true);
    let StepsLocale = getTourSteps(locale);
    setSteps(StepsLocale);
    setCurrentStep(0);

    let lstHelp = window.document.getElementById("lstHelp");
    lstHelp.className = "dropdown btn-group";
  }

  function SelectWhatsIsNew() {
    document.getElementById("onBoardingVisiblebutton").click();
    document.getElementById("whatsNewVisiblebutton").click();
    document.getElementById("WelComeVisiblebutton").click();
    document.getElementById("HideDoNotShowAgain").click();

    let lstHelp = window.document.getElementById("lstHelp");
    lstHelp.className = "dropdown btn-group";
  }

  function SelectWhatsIsNewTour() {
    // NO SE USA ACTUALMENTE
    setIsOpen(true);
    let StepsLocale = getWhatIsNewSteps(locale);
    setSteps(StepsLocale);
    setCurrentStep(0);

    // document.getElementById("stepcontainer").click();

    let lstHelp = window.document.getElementById("lstHelp");
    lstHelp.className = "dropdown btn-group";
  }
  function OpenLstHelps() {
    let lstHelps = window.document.getElementById("lstHelp");
    if (lstHelps.className === "dropdown btn-group") lstHelps.className = "dropdown open btn-group";
    else lstHelps.className = "dropdown btn-group";
  }

  return (
    <div className="HelpMenu" style={{ display: "" }}>
      <div className="dropdown btn-group" id="lstHelp" data-tutooo="reactour__conversionhelpbutton">
        <button onClick={OpenLstHelps} className="btn btn-default HelpMenuHeader"></button>
        <ul className="dropdown-menu dropdown-menu-right HelpMenuItem">
          <li key="SelectMyLectra" onClick={SelectMyLectra}>
            <a> MyLectra</a>
          </li>
          <li id="theDiscoveryTour" key="SelectTour" onClick={SelectDiscovery}>
            <a> {currentLocals(locale).HelpMenu.Discover_the_application}</a>
          </li>
          <li id="thewhatisnew" key="SelectWhatsIsNew" onClick={SelectWhatsIsNew}>
            <a> {currentLocals(locale).HelpMenu.Discover_the_latest_features}</a>
          </li>
          <li id="thewhatisnewTour" onClick={SelectWhatsIsNewTour} style={{ display: "none" }}>
            <a>{" el tour de antes"}</a>
          </li>
        </ul>
      </div>
    </div>
  );
};
export default HelpMenu;
